import React from "react";
import { useCarConfigSelector } from "../../../../../redux/store";
import styles from "./FinanceDisclaimerModal.module.scss";
//import table from "../../../../../common/css-modules/toyota/molecules/Table.module.scss";
import Text from "../../../../../../shared-components/css-modules/toyota/atoms/Text";
import type { ModalViewType } from "../../../../../../../../common-deprecated/types/CommonTypes";
import type { FinanceDisclaimerModalType } from "../../../../../utils/modalConstants";
import SidePanel from "../../../../../../shared-components/css-modules/toyota/organisms/SidePanel";
import tableStyles from "../../../../../../shared-components/css-modules/toyota/molecules/Table.module.scss";
import SanitizedRenderer from "../../../../../../../../common-deprecated/components/SanitizedRenderer";

const InsuranceDisclaimerModal = (props: ModalViewType<FinanceDisclaimerModalType>): JSX.Element | null => {
    const { show, close } = props;

    const insurance = useCarConfigSelector((state) => state.insurance);
    const hasDisclaimer = !!insurance.info.disclaimer?.table || insurance.info.disclaimer?.value;

    return (
        <SidePanel open={show} onRequestClose={close}>
            {!!hasDisclaimer && (
                <div className={styles["modal-inner"]}>
                    {insurance.info.disclaimer?.title && (
                        <Text tag="h2" variant="apheleia-h2">
                            <span dangerouslySetInnerHTML={{ __html: insurance.info.disclaimer?.title }} />
                        </Text>
                    )}

                    <table className={tableStyles.wrapper}>
                        {insurance.info.disclaimer?.table?.map((table, index) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <tr key={index}>
                                <td>
                                    <span dangerouslySetInnerHTML={{ __html: table.name }} />
                                </td>
                                <td>
                                    <span dangerouslySetInnerHTML={{ __html: table.value }} />
                                </td>
                            </tr>
                        ))}
                    </table>

                    {insurance.info.disclaimer?.value && (
                        <Text tag="p" variant="apheleia-body">
                            <SanitizedRenderer html={insurance.info.disclaimer?.value} />
                        </Text>
                    )}
                </div>
            )}
        </SidePanel>
    );
};

export default InsuranceDisclaimerModal;
